export const SKIP_REASON_TYPES = {
  skipped_later: 'skipped_later',
  skipped_dont_want: 'skipped_dont_want',
};
